import { render } from "./HasPermissions.vue?vue&type=template&id=1d93e4e7"
import script from "./HasPermissions.vue?vue&type=script&setup=true&lang=js"
export * from "./HasPermissions.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/partials/HasPermissions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1d93e4e7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1d93e4e7', __exports__)) {
    api.reload('1d93e4e7', __exports__)
  }
  
  module.hot.accept("./HasPermissions.vue?vue&type=template&id=1d93e4e7", () => {
    api.rerender('1d93e4e7', render)
  })

}


export default __exports__